import { render, staticRenderFns } from "./updateBulkPromotion.vue?vue&type=template&id=a6952a08&scoped=true&"
import script from "./updateBulkPromotion.vue?vue&type=script&lang=js&"
export * from "./updateBulkPromotion.vue?vue&type=script&lang=js&"
import style0 from "./updateBulkPromotion.vue?vue&type=style&index=0&id=a6952a08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6952a08",
  null
  
)

export default component.exports